import React from 'react';
import { withRouter } from '../../Utils/Component';
import { Result, Button } from 'antd';

function Page443() {
    return (
        <Result
			status="403"
			title="403"
			subTitle="Sorry, you are not authorized to access this page."
			extra={<Button type="primary" onClick={() => this.window.close()}>Back Home</Button>}
		/>
    )
}

export default withRouter(Page443);